"use strict";

(function () {

  // https://github.com/rbhatia46/Canvas-Snow/blob/master/snow.js

  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");

  canvas.style.cssText = "position: fixed; pointer-events: none; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; mix-blend-mode: soft-light";

  //set canvas fullscreen
  var W = window.innerWidth;
  var H = window.innerHeight;
  canvas.height = H;
  canvas.width = W;

  //generate snowflakes and atts
  var mf = 50; //max flakes
  var flakes = [];

  //loop through empty flakes and apply atts
  for (var i = 0; i < mf; i++) {
    flakes.push({
      x: Math.random() * W, //set width of flake to random nr between 0 and 1 * width of screen
      y: Math.random() * H, //set height of flake to random nr between 0 and 1 * height of screen
      r: Math.random() * 2 + 1, //set radius between 2 and 5
      d: Math.random() + 1
    });
  }

  //draw flakes
  function drawFlakes() {
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "White";
    ctx.beginPath();
    for (var _i = 0; _i < mf; _i++) {
      var f = flakes[_i];
      ctx.moveTo(f.x, f.y);
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2, true);
    }
    ctx.fill();
    moveFlakes();
    requestAnimationFrame(drawFlakes);
  }
  var angle = 0;
  //move flakes
  function moveFlakes() {
    angle += 0.005;
    for (var _i2 = 0; _i2 < mf; _i2++) {
      var f = flakes[_i2];
      f.y += Math.pow(f.d, 1.2) + .2;
      f.x += Math.cos(angle) * 1.2;

      if (f.y > H) {
        flakes[_i2] = { x: Math.random() * W, y: 0, r: f.r, d: f.d };
      }
    }
  }

  drawFlakes();
  document.querySelector('body').appendChild(canvas);

  window.addEventListener('resize', function () {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.height = H;
    canvas.width = W;
    flakes.forEach(function (f) {
      f.x = Math.random() * W;
      f.y = Math.random() * H;
    });
    return true;
  });
})();